import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useAnimatedValue,
  AnimatedBlock,
  interpolate,
  useAuth,
  useNavigation,
} from "react-uicomp";

import { getNewsAction } from "../../../actions/Actions";

// COMMONS
import ActiveIndex from "../../common/activeIndex/ActiveIndex.common";
import { PrimaryButton } from "../../common/button/Button.common";

import BackgroundImage from "../../../assets/images/bg_1.jpg";
import BackgroundImage2 from "../../../assets/images/bg_2.jpg";
import BackgroundImage3 from "../../../assets/images/bg_3.jpg";

const SLIDER_IMAGES = [
  { image: BackgroundImage },
  { image: BackgroundImage2 },
  { image: BackgroundImage3 },
];

const NOTICES = [
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC)
     was established in 1991 as an autonomous
      organization under 
      "Nepal Agricultural Research Council Act - 1991"
     was established in 1991 as an autonomous
      organization under 
      "Nepal Agricultural Research Council Act - 1991"
     was established in 1991 as an autonomous
      organization under 
      "Nepal Agricultural Research Council Act - 1991"
     was established in 1991 as an autonomous
      organization under 
      "Nepal Agricultural Research Council Act - 1991"
     was established in 1991 as an autonomous
      organization under 
      "Nepal Agricultural Research Council Act - 1991"
     was established in 1991 as an autonomous
      organization under 
      "Nepal Agricultural Research Council Act - 1991"
     was established in 1991 as an autonomous
      organization under 
      "Nepal Agricultural Research Council Act - 1991"
       to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
  {
    title: "नेपाल कृषि अनुसन्धान परिषद्को अनुरोध",
    description: `Nepal Agricultural Research Council (NARC) was established in 1991 as an autonomous organization under "Nepal Agricultural Research Council Act - 1991" to conduct agricultural research in the country to uplift the economic level of the people.`,
  },
];

export const Notices = () => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const animation = useAnimatedValue(activeImageIndex);
  const { language } = useAuth();
  const { navigation } = useNavigation();
  const { navigate, routes } = navigation;

  const dispatch = useDispatch();
  const { listLoader, list } = useSelector((state) => state.news);

  useEffect(() => {
    dispatch(getNewsAction());
  }, [getNewsAction]);

  useEffect(() => {
    const interval = setInterval(function () {
      setActiveImageIndex((prev) => (prev + 1) % 2);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="notices-carousel-container">
      <div className="activeIndicator-container">
        <ActiveIndex
          length={list?.length}
          activeIndex={activeImageIndex}
          setActiveIndex={setActiveImageIndex}
        />
      </div>

      {/* IMAGE SLIDER */}
      <div style={{ overflow: "hidden", height: "100%" }}>
        <AnimatedBlock
          className="notices-slider-container"
          style={{
            left: interpolate(
              animation.value,
              list?.map((_, i) => i),
              list?.map((_, i) => -1 * i * 100 + "%"),
            ),
          }}>
          {list?.map((val, index) => (
            <div
              key={index}
              className="notices-slider"
              onClick={() =>
                navigate(routes["News & Notices"].path + `/${val.id}`)
              }>
              <div className="notice-title">{val.title}</div>
              <div className="notice-description">
                {val.description?.shortDesc?.en}
              </div>
            </div>
          ))}
        </AnimatedBlock>
      </div>
    </div>
  );
};
